import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { PayrollCalendarRequestParams } from '../payrollCalendar.types';

const getCalculatePayrollCalendarSchedule = (params: PayrollCalendarRequestParams) => {
  return api.get<string[]>(API_URL.PAYROLL_CALENDARS_CALCULATE_SCHEDULE, { params });
};

const useCalculatePayrollCalendarScheduleQuery = () => {
  const { mutateAsync, isLoading } = useMutation((params: PayrollCalendarRequestParams) =>
    getCalculatePayrollCalendarSchedule(params)
  );

  const calculateSchedule = useCallback(
    async (params: PayrollCalendarRequestParams) => {
      const response = await mutateAsync(params);
      return response?.data;
    },
    [mutateAsync]
  );

  return {
    calculateSchedule,
    isLoading,
  };
};

export default useCalculatePayrollCalendarScheduleQuery;
